import type { ChatMessage, ChatPart } from '@core/tellent-assistant-types';

type TextPart = Extract<ChatPart, { kind: 'text' }>;
type ToolCallPart = Extract<ChatPart, { kind: 'tool-call' }>;
type ToolResultPart = Extract<ChatPart, { kind: 'tool-result' }>;

export interface ClassifiedDataTool {
  toolCallId: string;
  name: string;
  status: ToolCallPart['status'];
  hasResult: boolean;
}

export interface AssistantMessagePhases {
  preamble: TextPart | null;
  dataTools: ClassifiedDataTool[];
  renderTools: ToolCallPart[];
  finalText: TextPart | null;
}

export const classifyAssistantMessage = (
  msg: ChatMessage,
  renderToolNames: ReadonlySet<string>,
): AssistantMessagePhases => {
  const phases: AssistantMessagePhases = {
    preamble: null,
    dataTools: [],
    renderTools: [],
    finalText: null,
  };

  if (msg.role !== 'assistant') return phases;

  const resultsByCallId = new Map<string, ToolResultPart>();
  for (const p of msg.parts) {
    if (p.kind === 'tool-result') resultsByCallId.set(p.toolCallId, p);
  }

  let lastTextPart: TextPart | null = null;

  for (const p of msg.parts) {
    if (p.kind === 'text') {
      if (phases.preamble === null) {
        phases.preamble = p;
      } else {
        lastTextPart = p;
      }
      continue;
    }
    if (p.kind === 'tool-call') {
      if (renderToolNames.has(p.name)) {
        phases.renderTools.push(p);
      } else {
        phases.dataTools.push({
          toolCallId: p.toolCallId,
          name: p.name,
          status: p.status,
          hasResult: resultsByCallId.has(p.toolCallId),
        });
      }
    }
  }

  if (lastTextPart && lastTextPart.content !== phases.preamble?.content) {
    phases.finalText = lastTextPart;
  }
  return phases;
};
